<template>
    <div class="webinar-questions">
        <template v-if="error">
            <div class="error">
                <img src="./../assets/images/icon-error.png" alt="error" />
                <p v-html="error"></p>
            </div>
        </template>
        <template v-if="!error && webinar">
            <h1>{{webinar.name}}<br />{{webinar.speaker_title}} {{webinar.firstname}} {{webinar.lastname}}   </h1>
            <div class="questions-container" v-if="questions">
                <div class="questions-item" v-for="(item, idx) in questions" :key="idx">
                    <div class="questions-header">{{ item.webinar_video_question_question }} - <span>{{ item.webinar_video_question_current_time }}</span></div>
                    <div class="questions-answer">
                        Answer : {{ item.webinar_video_question_answer }} 
                    </div>
                </div>
            </div>
            <div class="no-questions" v-else>
                <p>No questions</p>
            </div>
        </template>
    </div>
</template>

<script>
import axios from 'axios'
import store from './../store'

export default {
    name : 'WebinarQuestions',
    data() {
        return {
            questions : null,
            webinar : null,
            error: null
        }
    },
    mounted() {
                let vm = this
        this.error = null

        axios
            .get(store.getters.getURL + "webinars/getUserQuestions.php?user="+store.state.AUTH.user_id+"&webinar="+this.$route.params.id+"&token="+store.state.JWT_TOKEN )
            .then(function (response) { 
                if(response.data.state == 'success') {
                    vm.webinar = response.data.infos
                    vm.questions = response.data.res
                }else {
                    if(response.data.authError) {
                        store.commit('logout')
                        vm.$router.push('/login')
                    }else {
                        vm.error = response.data.retour
                    }
                }
            })
            .catch((err) => {
                this.error = 'An error has occured:' +  err
            });
    }
}
</script>

<style lang="scss" scoped>
h2 {
    text-align: center;
}

.webinar-questions {
    width:1450px;
    max-width: 95%;
    margin:50px auto 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
}

.no-questions p{
    font-size:18px;
    text-align: center;
    margin-top: 80px;
}

.questions-item {
    padding:40px 0;
    border-bottom:1px solid $mainColor;
}

.questions-header {
    font-size:18px;
}

.questions-header span {
    font-style:italic;
}

</style>